export const getScrollingElement = () =>
  document.getElementById('root').parentElement;
